import React from 'react';

import { TBlock } from '@wp-block-builder/package';

type Props<T extends TBlock['type']> = { block: Extract<TBlock, { type: T }> };
type BlockComponentConfiguration = {
  Avatar: ({ block }: Props<'Avatar'>) => JSX.Element;
  Button: ({ block }: Props<'Button'>) => JSX.Element;
  ColumnsSection: ({ block }: Props<'ColumnsSection'>) => JSX.Element;
  Container: ({ block }: Props<'Container'>) => JSX.Element;
  ContainerYield: ({ block }: Props<'ContainerYield'>) => JSX.Element;
  Divider: ({ block }: Props<'Divider'>) => JSX.Element;
  Heading: ({ block }: Props<'Heading'>) => JSX.Element;
  Html: ({ block }: Props<'Html'>) => JSX.Element;
  Image: ({ block }: Props<'Image'>) => JSX.Element;
  LoopContainer: ({ block }: Props<'LoopContainer'>) => JSX.Element;
  ProgressBar: ({ block }: Props<'ProgressBar'>) => JSX.Element;
  Spacer: ({ block }: Props<'Spacer'>) => JSX.Element;
  Text: ({ block }: Props<'Text'>) => JSX.Element;
};

export default function buildBlockComponent(conf: BlockComponentConfiguration) {
  return ({ block }: { block: TBlock }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const Component: any = conf[block.type];
    return <Component block={block} />;
  };
}
